import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../../../src/components/Reveal";
import { SERVICES } from "../../../src/data/services";

export default function PracticeAreas() {
  return (
    <section
      data-testid="home-practice-areas"
      className="section-pad"
      style={{ background: "#F8F9FA" }}
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal>
            <div className="flex items-center gap-3 mb-4">
              <span className="gold-rule" />
              <span className="overline">Áreas de práctica</span>
            </div>
            <h2 className="font-serif text-navy-900 text-3xl md:text-4xl lg:text-5xl leading-tight max-w-2xl">
              Asesoría especializada en cada frente del derecho empresarial.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <Link
              to="/servicios"
              data-testid="practice-cta-ver-todos"
              className="inline-flex items-center gap-2 text-sm font-medium text-navy-900 under-gold"
            >
              Ver todos los servicios
              <ArrowRight size={15} />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-px bg-slate-200">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.slug} delay={i * 40}>
                <Link
                  to={`/servicios/${s.slug}`}
                  data-testid={`practice-card-${s.slug}`}
                  className="group relative h-full bg-white p-7 md:p-8 flex flex-col transition-all duration-300 hover:bg-navy-900"
                >
                  <Icon
                    size={28}
                    strokeWidth={1.4}
                    className="mb-6 transition-colors"
                    style={{ color: "#C5A059" }}
                  />
                  <h3 className="font-serif text-lg md:text-xl text-navy-900 group-hover:text-white transition-colors leading-snug">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-500 group-hover:text-slate-300 transition-colors leading-relaxed flex-1">
                    {s.short}
                  </p>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-slate-400 group-hover:text-gold transition-colors">
                    Conocer
                    <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}